import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../components/Reveal';
import SmoothImage from '../components/SmoothImage';
import { forEveryoneLookbook, collections } from '../mock/mock';

const ForEveryone = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const collection = collections.find((c) => c.id === 'for_everyone');
  const cover = collection?.heroImage || '/items/fe-hero.jpg';
  const rest = forEveryoneLookbook;

  return (
    <div className="bg-white" data-testid="for-everyone-page">
      {/* HERO */}
      <section className="relative h-screen w-full overflow-hidden bg-neutral-200">
        <div className="absolute inset-0">
          <SmoothImage
            src={cover}
            alt="For Everyone — Andobrée"
            loading="eager"
            fetchPriority="high"
            className="w-full h-full"
            imgClassName="scale-[1.02]"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/40" />
        <div className="relative z-10 h-full flex flex-col items-start justify-end px-6 lg:px-20 pb-24 max-w-[1600px] mx-auto">
          <Reveal variant="fade" duration={800}>
            <p className="text-[11px] tracking-[0.32em] uppercase text-white/80 mb-6" data-testid="for-everyone-eyebrow">
              The Collection
            </p>
          </Reveal>
          <Reveal delay={140} duration={1000}>
            <h1 className="font-display italic text-white text-6xl md:text-8xl lg:text-9xl font-light leading-[0.95] tracking-tight" data-testid="for-everyone-title">
              For Everyone.
            </h1>
          </Reveal>
          <Reveal delay={320} duration={800}>
            <p className="mt-10 max-w-xl text-white/85 text-base md:text-lg font-light leading-relaxed">
              {collection?.tagline ||
                'A celebration of every body, every story — captured in our debut lookbook.'}
            </p>
          </Reveal>
        </div>
      </section>

      {/* LOOKBOOK — same grid layout as the Shop product grid */}
      <section className="pt-24 pb-32 px-6 lg:px-12">
        <div className="max-w-[1600px] mx-auto">
          <div className="text-center mb-16">
            <Reveal variant="fade" duration={600}>
              <p className="text-[11px] tracking-[0.22em] uppercase text-neutral-500 mb-5">
                Lookbook
              </p>
            </Reveal>
            <Reveal delay={100}>
              <h2 className="font-display text-5xl md:text-6xl font-medium tracking-tight">
                Every body. Every story.
              </h2>
            </Reveal>
            <Reveal delay={220} variant="fade">
              <p className="mt-5 text-sm text-neutral-500">{rest.length} images</p>
            </Reveal>
          </div>

          <div className="border-t border-neutral-200 pt-10">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 lg:gap-10">
              {rest.map((src, i) => (
                <Reveal key={src} delay={(i % 4) * 90} duration={750}>
                  <div
                    className="block"
                    data-testid={`lookbook-tile-${i}`}
                  >
                    <div className="relative aspect-[3/4] mb-5 overflow-hidden bg-neutral-100">
                      <SmoothImage
                        src={src}
                        alt={`For Everyone lookbook image ${i + 1}`}
                        className="w-full h-full"
                      />
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CLOSER */}
      <section className="py-32 px-6 bg-neutral-100">
        <div className="max-w-3xl mx-auto text-center">
          <Reveal variant="fade" duration={600}>
            <p className="text-[11px] tracking-[0.22em] uppercase text-neutral-500 mb-10">
              Fashion is for everyone
            </p>
          </Reveal>
          <Reveal delay={150} duration={1000}>
            <blockquote className="font-display italic text-4xl md:text-5xl font-light text-neutral-700 leading-tight tracking-tight">
              &ldquo;Be unique with us.&rdquo;
            </blockquote>
          </Reveal>
          <Reveal delay={400} variant="fade" duration={600}>
            <Link
              to="/shop"
              data-testid="lookbook-shop-cta"
              className="inline-block mt-14 text-[11px] tracking-[0.28em] uppercase border-b border-neutral-900 pb-2 hover:tracking-[0.32em] transition-all duration-500"
            >
              Shop the Pieces
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default ForEveryone;
